export const GET_DETAILS = "GET_DETAILS";
export const UPDATE_SITE_CONTACT = "UPDATE_SITE_CONTACT";
export const UPDATE_STREET_VIEW = "UPDATE_STREET_VIEW";
export const UPDATE_RA = "UPDATE_RA";
